import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";

const ClientPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



    const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    };

  const handleZaloClick = () => {
    window.open("https://zalo.me/0919345169", "_blank");
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+84919345169";
  };

  const handleFacebookClick = () => {
    window.open("https://www.facebook.com/shophoathanhflower", "_blank");
  };

  return (
    <div>
      <Header />
      <Outlet />
      <Footer />
      <div
        onClick={scrollToTop}
        className={`scroll-to-top ${isVisible ? "show" : ""}`}
      >
        <i className="bi bi-chevron-up"></i>
      </div>
      <div className="contact-home" onClick={handlePhoneClick}>
        <i className="bi bi-telephone-fill"></i>
      </div>

      <div className="contact-home-zalo" onClick={handleZaloClick}>
        <img
          src="https://img.icons8.com/?size=100&id=82445&format=png&color=00A4FF"
          alt=""
          width={30}
          height={30}
          style={{ backgroundColor: "#fff" }}
        />
      </div>

      <div className="contact-home-facebook" onClick={handleFacebookClick}>
        <i className="bi bi-facebook"></i>
      </div>
    </div>
  );
};

export default ClientPage;
